import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { CONTROL_MARGIN } from "../../MuiThemes";
import { getHelperText, propertyHasErrors } from "./inputHelpers";
import { DecimalCustomControlProps } from "../../Utils/Interfaces";

export default function NumberEditor(props: DecimalCustomControlProps): JSX.Element {
    const originalValue = props.initialValue?.toFixed(props.precision) ?? "";
    const [inputValue, setInputValue] = useState<string>(originalValue);

    return (
        <>
            <TextField
                id={props.sourceProperty}
                margin={CONTROL_MARGIN}
                fullWidth
                value={inputValue}
                autoComplete="off"
                onChange={(e) => handleOnChange(e.target.value)}
                onBlur={handleBlur}
                inputProps={{ inputMode: "numeric", style: { textTransform: "uppercase", textAlign: "right" } }}
                label={props.labelText}
                error={propertyHasErrors(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                helperText={getHelperText(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
            />
        </>
    );

    function handleOnChange(value: string): void {
        if (props.precision === 0) {
            if (!value || value.match(/^\d{0,}?$/)) {
                setInputValue(value);
            }
        } else if (props.precision === 1) {
            if (!value || value.match(/^\d{0,}(\.\d{0,1})?$/)) {
                setInputValue(value);
            }
        } else {
            throw new Error(`unsupported numberEditor precision: ${props.precision}`);
        }
    }

    function handleBlur(): void {
        const valueAsNumber = Number(inputValue);
        if (valueAsNumber.toFixed(props.precision) !== originalValue) {
            props.mergeChanges(props.sourceId, { [props.sourceProperty]: inputValue === "" || isNaN(valueAsNumber) ? null : valueAsNumber });
        }
    }
}
